// import {
//   Info as Icon
// } from 'components/icons';

import React from 'react';
import { Icon } from "semantic-ui-react";

function TheIcon (props) {
  return <Icon name="location arrow" {...props} />;
  // return <Icon name="tags" {...props} />;
}

export const meta = {
  id: 'CMSPAGESCATEGORIES',
  title: 'Categories',
  category: 'CMS',
  exposes: [
    {
      title: 'Categories',
      action: { module: 'CMSPAGESCATEGORIES', props: { /* */ } },
    },
    {
      title: 'New Category',
      action: {
        module: 'CMSPAGESCATEGORIESDetails',
        props: { context: 'add' }
      },
    },
    {
      title: 'CMSTags',
      action: { module: 'CMSTags', props: { /* */ } },
    },
    {
      title: 'New CMSTags',
      action: { module: 'CMSTagsDetails', props: { context: 'add' } },
    }
  ],
  unique: true,
  icon: TheIcon,
  version: '1.0.0',
  description: `<!-- TODO: add a description here! -->`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
